import React from "react";
import { useOutletContext } from "react-router-dom";
import AccountListPage from "../features/userManagement/AccountListPage";

const Customers = () => {
  const context = useOutletContext() || {};
  return <AccountListPage type="customers" language={context.language} direction={context.direction} />;
};

export default Customers;
